import {
    Box,
    Card,
    Grid,
    Stack,
    TextField,
    Typography,
    Switch,
    Button,
    CircularProgress,
    InputAdornment,
    IconButton,
    Slide,
    Dialog,
    DialogTitle,
    ListItem,
    DialogContent,
    DialogContentText,
    Tooltip,
    List,
    Divider
} from "@mui/material";
import { CloseRounded, RemoveRedEyeRounded, Shield } from "@mui/icons-material";
import { AgGridTable } from "components/tables/AgGridTable";
import CommonLayout from "layouts/DashboardLayout";
import { useDispatch } from "react-redux";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { closeCustomModalDialog, openCustomModalDialog } from "../../redux/slices/modalSlice";
import { fetchLogCanpay, fetchUpdateStatus, gettransactionsList, UpdateRefundStatus, updateStatus } from "../../redux/slices/hyperwolf/settings";
import { openSnackbar } from "../../redux/slices/common";
import MDBox from "components/MDBox";
import { formatUsPhoneNumber } from "utilities/common";
import InActiveIcon from "common/customIcons/inactive";
import InProgressIcon from "common/customIcons/inprogress";
import ActiveIcon from "common/customIcons/active";
import { formatTimestampToDateView } from "utilities/common";
import SearchIcon from "common/customIcons/search";
import { useDebounce } from "hooks/useDebounce";
import MDButton from "components/MDButton";
import CloseIcon from '@mui/icons-material/Close';
import { grey, red } from "@mui/material/colors";
import Loader from 'common/Loader';
import { Riple } from "react-loading-indicators";
import { getPermissionsByMode } from "utilities/common";
import { getData } from "utilities/common";
import { hasSectionPermission } from "utilities/common";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction='left' ref={ref} {...props} />;
});

export default function ManagePaymentSetting() {
    const mainGridApiRef = useRef('');
    const gridRefApi = useRef(null);
    const pageRef = useRef(0);
    const dispatch = useDispatch();
    const searchTermRef = useRef('');
    const productsRef = useRef([]); // Ref to store products data
    const [logNotesData, setLogNotesData] = useState('')
    const [isLogNotes, setIsLogNotes] = useState('')

    let localUser = getData('login-user-info')
    if (localUser) {
        localUser = JSON.parse(localUser)
    }

    const adminMode = localStorage.getItem("adminsMode") ? JSON.parse(localStorage.getItem("adminsMode")) : null;
    const permissionsForMode = getPermissionsByMode(localUser?.permissions, adminMode);

    const canCreate = hasSectionPermission(permissionsForMode, "Settings", "Create");
    const canEdit = hasSectionPermission(permissionsForMode, "Settings", "Edit/Update");
    const canView = hasSectionPermission(permissionsForMode, "Settings", "View Only");
    const canDelete = hasSectionPermission(permissionsForMode, "Settings", "Delete");

    const [formData, setFormData] = useState({
        canpaystatus: "",
    })
    const [searchTerm, setSearchTerm] = useState('');

    const { isLoading, islogLoading, transactionsList, isgetLoading } = useSelector(state => state.hyperwolfSettings);

    const statusObj = {
        Completed: <Box color="#24CA49" display="flex" alignItems="center">
            <ActiveIcon width="18px" height="18px" flex="none" />
            <Typography variant='caption' fontWeight="regular" ml={.5} textTransform="capitalize">Delivered</Typography>
        </Box>,
        Accepted: <Box color="#FFBF00" display="flex" alignItems="center">
            <ActiveIcon width="18px" height="18px" flex="none" />
            <Typography variant='caption' fontWeight="regular" ml={.5} textTransform="capitalize">Accepted</Typography>
        </Box>,
        shipped: <Box color="#24CA49" display="flex" alignItems="center">
            <ActiveIcon width="18px" height="18px" flex="none" />
            <Typography variant='caption' fontWeight="regular" ml={.5} textTransform="capitalize">Shipped</Typography>
        </Box>,
        CanceledByDispensary: <Box color="#FD4438" display="flex" alignItems="center">
            <InActiveIcon width="18px" height="18px" flex="none" />
            <Typography variant='caption' fontWeight="regular" ml={.5} textTransform="capitalize">Cancelled</Typography>
        </Box>,
        pending: <Box color="#8E0CF5" display="flex" alignItems="center">
            <InProgressIcon width="18px" height="18px" flex="none" />
            <Typography variant='caption' fontWeight="regular" ml={.5} textTransform="capitalize">In Progress</Typography>
        </Box>,
        on_hold: <Box color="#FF7A2F" display="flex" alignItems="center">
            <InProgressIcon width="18px" height="18px" flex="none" />
            <Typography variant='caption' fontWeight="regular" ml={.5} textTransform="capitalize">On Hold</Typography>
        </Box>,

    }

    const columnDefs = [
        {
            headerName: 'Transaction ID	',
            field: 'transNo',
            // sortable: false,
            suppressMenu: false,
            minWidth: 100,
            flex: 1,
            cellRenderer: (props) => {
                return props?.value ? props?.value : "-"
            },
            cellStyle: { whiteSpace: 'normal', lineHeight: '1.5' },
            sortable: false,
        },
        {
            headerName: 'Email/Phone',
            field: 'email_phone',
            key: "",
            sortable: false,
            suppressMenu: false,
            cellRenderer: (props) => {
                return <MDBox textAlign="left">
                    <Typography variant="caption" display="block" fontWeight="regular">{props?.data?.email}</Typography>
                    <Typography variant="caption" display="block" color="secondary" mt={.5}>{props?.data?.phone ? formatUsPhoneNumber(props?.data?.phone) : '-'}</Typography>
                </MDBox>
            },
            minWidth: 300,
        },
        {
            headerName: 'Amount',
            field: 'total',
            sortable: false,
            // sortable: false,
            suppressMenu: false,
            minWidth: 100,
            flex: 1,
            cellRenderer: (props) => {
                return props?.value ? `$${props?.value}` : "$0"
            },
            cellStyle: { whiteSpace: 'normal', lineHeight: '1.5' },

        },
        {
            headerName: 'Status',
            field: 'status',
            suppressMenu: false,
            sortable: false,
            cellRenderer: (props) => {
                return <>{statusObj[props?.data?.status || "awaiting_shipment"]}</>
            },
            minWidth: 140,
            cellStyle: { whiteSpace: 'normal', lineHeight: '1.5' },

        },
        {
            headerName: 'Refund Status	',
            field: 'refundStatus',
            sortable: false,
            suppressMenu: false,
            minWidth: 100,
            flex: 1,
            cellRenderer: (props) => {
                return <> {(props?.data?.paymentOption === "ACH" && props?.data?.status === "CanceledByDispensary") ? props?.value ? 'Refunded' : "No Refund" : "-"}
                </>
            },
            cellStyle: { whiteSpace: 'normal', lineHeight: '1.5' },

        },
        {
            headerName: 'Created Date',
            field: 'createdDate',
            suppressMenu: false,
            cellRenderer: (props) => {
                return props?.value ? formatTimestampToDateView(props?.value) : '-';
            },
            // autoHeight: true,
            sortable: false,
        },
        {
            headerName: 'Logs',
            field: 'notes',
            suppressMenu: false,
            cellRenderer: (props) => {
                return props?.data?.orderId ? <MDButton
                    disabled={!(props?.data?.status !== "pending" || props?.data?.paymentOption !== "ACH")}
                    onClick={() => {
                        setIsLogNotes(true)
                        fetchLogCanpaybyID(props?.data?.orderId);
                    }} size='small' startIcon={<RemoveRedEyeRounded fontSize='small' />} variant='contained' color='primary' className='btn-primary-light'>
                    View logs
                </MDButton> : null;
            },
            minWidth: 160,
        },
        {
            headerName: 'Action',
            field: 'Amount',
            sortable: false,
            suppressMenu: false,
            minWidth: 100,
            flex: 1,
            cellRenderer: (props) => {
                return <Button
                    disabled={props?.data?.status !== "pending" || props?.data?.paymentOption !== "ACH"}
                    onClick={() => {
                        dispatch(openCustomModalDialog({ modal: 'PAYMENT_REASON', modalData: { payOrderStatus, refundTotal: props?.data?.total, orderId: props?.data?.orderId, } }));
                    }}
                    variant="contained"
                    color="primary"
                    style={{ fontWeight: "normal", fontSize: "12px", padding: "8px 22px", minHeight: "auto" }}
                >
                    Refund
                </Button>
            },
            cellStyle: { whiteSpace: 'normal', lineHeight: '1.5', textAlign: 'right', justifyContent: 'end' },
            headerClass: 'right-aligned-cell-header',
        },
    ];

    const fetchLogCanpaybyID = (id) => {
        dispatch(fetchLogCanpay({ data: id })).unwrap().then((res => {
            setLogNotesData(res?.data?.canpayData)

        }))

    }

    const payOrderStatus = useCallback((reason) => {
        dispatch(UpdateRefundStatus({ data: reason })).unwrap().then((res => {
            showError(res?.data?.message, 'success');
            searchFn();
            dispatch(closeCustomModalDialog());
        })).catch((err => {
            showError(err?.message, 'error');
        }));

    })

    function getSortInfo(data) {
        const sortInfo = {
            sortBy: '',
            sortOrder: ''
        };
        data.forEach(item => {
            sortInfo.sortBy = item.colId;
            sortInfo.sortOrder = item.sort === "asc" ? 'asc' : 'desc';
        });
        return sortInfo;
    }
    const getRows = async (params, value) => {
        gridRefApi.current = params;
        let filter = {};
        if (params?.sortModel.length) {
            filter = { ...getSortInfo(params?.sortModel) };
        }

        // Make the API call with filters
        dispatch(gettransactionsList({
            skip: 0,
            limit: 20,
            searchTerm: searchTermRef.current,
            ...(Array.isArray(value) && value.length > 0 ? { platform: value.join(",") } : {}),
            ...filter,
        }))
            .unwrap().then(res => {
                const { transactions = [], total } = res?.data;

                productsRef.current = transactions;

                // Handle the status on the frontend side
                const modifiedBlogs = transactions.map((item) => ({
                    ...item,
                }));
                // Pass the modified data to the grid
                params.successCallback(modifiedBlogs, total);

                // Update the page reference
                pageRef.current = pageRef.current + 20;
            }).catch((err) => {
                params.successCallback([], 0);
            });
    };

    useEffect(() => {
        if (mainGridApiRef?.current) {
            if (isgetLoading) {
                mainGridApiRef.current.showLoadingOverlay();
            } else if (transactionsList?.total === 0) {
                mainGridApiRef.current.showNoRowsOverlay();
            }
            else {
                mainGridApiRef.current.hideOverlay();
            }
        }
    }, [transactionsList, isgetLoading])

    const handleStatusUpdate = (e) => {
        setFormData({
            ...formData,
            canpaystatus: e.target.checked
        });
        const payload = {
            canpaystatus: e.target.checked,
        }
        dispatch(updateStatus(payload))
            .unwrap()
            .then((res) => {

                showError(res?.message, 'success')
                dispatch(fetchUpdateStatus())
            })
            .catch((err) => {
                showError(err?.message, 'error')
            });
    }
    useEffect(() => {
        dispatch(fetchUpdateStatus()).unwrap()
            .then((res) => {
                // showError(res?.message, 'success')
                setFormData({
                    canpaystatus: res?.canpaystatus,
                })
            })
            .catch((err) => {
                // showError(err?.message, 'error')
            });
    }, [])
    const showError = (message, errortype) => {
        if (errortype === 'success') {
            dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }));
        }
        if (errortype === 'error') {
            dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }));
        }
    };

    const searchHandler = (searchValue) => {
        setSearchTerm(searchValue);
        searchTermRef.current = searchValue;
        handleSearch(searchValue);
    };

    const handleSearch = useDebounce(() => {
        pageRef.current = 0;
        searchFn();
    }, 500);

    const searchFn = (value) => {
        const dataSource = {
            getRows: (params) => getRows(params, value) // Pass the current filter payload
        };
        mainGridApiRef.current.ensureIndexVisible(0, null);
        mainGridApiRef.current.setGridOption('datasource', dataSource);
    };

    return (
        <CommonLayout>
            <Box p={{ xs: 2, sm: 3, lg: 4 }}>
                <Typography variant="h4" fontWeight="semibold" mb={2}>Payment Settings</Typography>
                <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3}>
                        <Box display="flex" alignItems="start" flexDirection="column" gap={1.25}>
                            <Typography variant='h4' fontWeight="semibold" style={{ color: "#2E2E3A", fontSize: "1.125rem" }}>CAN Pay</Typography>
                            <Typography variant='body2' fontWeight='regular'>Enable or disable CAN Pay payment method for customers</Typography>
                        </Box>
                        <Switch disabled={isLoading || !canEdit} checked={formData?.canpaystatus} name='batchToggle' onChange={(e) => handleStatusUpdate(e)} />
                        {/* {
                            isLoading &&
                            <CircularProgress
                                size={20} // Matches Switch thumb size
                                sx={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "90%",
                                    marginTop: "-7px", // Half of size (24/2)
                                    marginLeft: "-50px",
                                }}
                            />
                        } */}
                    </Stack>
                </Card>

                <Card sx={{ p: { xs: 2, md: 3 }, borderRadius: 2.5, boxShadow: 'none' }}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={2}>
                        <Typography variant='h4' fontWeight="semibold" style={{ color: "#2E2E3A", fontSize: "1.125rem" }}>Refund Management</Typography>
                        <Box display="flex" alignItems="center" gap={1.25} className="search-grey-border">
                            <TextField className="custom-search-field" placeholder="Search" label="" value={searchTerm} onChange={(e) => searchHandler(e.target.value)}
                                sx={{ minWidth: "300px" }}
                                InputProps={{
                                    startAdornment: <InputAdornment position="start">
                                        <IconButton size='small'>
                                            <SearchIcon width='18px' height='18px' />
                                        </IconButton>
                                    </InputAdornment>,
                                    endAdornment: searchTerm?.length > 0 ? <InputAdornment>
                                        <IconButton onClick={() => searchHandler('')} size='small'>
                                            <CloseRounded />
                                        </IconButton>
                                    </InputAdornment> : null
                                }}
                            />

                            <Typography variant='body2' fontWeight='semibold' color="#0163FF">{transactionsList?.total ? transactionsList?.total : 0} Total Transactions</Typography>
                        </Box>
                    </Stack>
                    {
                        canView &&
                        <AgGridTable col={columnDefs} getRows={getRows} mainGridApiRef={mainGridApiRef} pageRef={pageRef} isLoading={isgetLoading} style={{ height: '70vh' }} />
                    }
                </Card>
            </Box>
            <Dialog open={Boolean(isLogNotes)} TransitionComponent={Transition} keepMounted maxWidth='xs' fullWidth className='notes-modal'
                onClose={() => { setLogNotesData(''), setIsLogNotes(false) }}
                aria-describedby='alert-dialog-slide-description'
            >
                <DialogTitle id='draggable-dialog-title' display='flex' alignItems='center' justifyContent='space-between' mb={0.5}>
                    {'View Logs'}
                    <IconButton onClick={() => { setLogNotesData(''); setIsLogNotes(false) }} edge='end' size='small'>
                        <CloseIcon fontSize='medium' />
                    </IconButton>
                </DialogTitle>

                <DialogContent className='notes-modal-body'>
                    <DialogContentText id='alert-dialog-slide-description'>
                        {
                            islogLoading ?
                                <div className="text-center">
                                    <Riple color='#3135cc' size='medium' text='' textColor='' textAlign='center' />
                                </div>
                                :
                                <>
                                    <List>

                                        <ListItem>
                                            <Typography variant="body2" fontWeight="medium">Updated By</Typography>
                                            <Typography variant="body2" fontWeight="semibold" > {logNotesData?.updatedBy}</Typography>
                                        </ListItem>
                                        <Divider component='li' />
                                        <ListItem>
                                            <Typography variant="body2" fontWeight="medium">Updated Date</Typography>
                                            <Typography variant="body2" fontWeight="semibold" > {formatTimestampToDateView(logNotesData?.updatedDate)}</Typography>
                                        </ListItem>
                                        <Divider component='li' />
                                        <ListItem>
                                            <Typography variant="body2" fontWeight="medium">Canpay Amount</Typography>
                                            <Typography variant="body2" fontWeight="semibold" > {logNotesData?.canpayAmount ? `$${logNotesData?.canpayAmount}` : "-"}</Typography>
                                        </ListItem>
                                        <Divider component='li' />
                                        <ListItem>
                                            <Typography variant="body2" fontWeight="medium">Reason</Typography>
                                            {
                                                logNotesData?.cancellationReason?.length > 50 ? <>
                                                    <Tooltip title={logNotesData?.cancellationReason}>
                                                        <Typography variant="body2" fontWeight="medium" mb={0.5} color={red[600]}>  {logNotesData?.cancellationReason?.slice(0, 50) + '...'}</Typography>
                                                    </Tooltip>

                                                </> : <Typography variant="body2" fontWeight="medium" mb={0.5} color={red[600]}>  {logNotesData?.cancellationReason}</Typography>
                                            }
                                        </ListItem>
                                    </List>
                                </>
                        }

                    </DialogContentText>
                </DialogContent>
            </Dialog>
        </CommonLayout>
    )

}